import { api } from '@/global/api'
import {
  AppointmentType,
  EstablishmentsArgs,
  EstablishmentCategory
} from '@/modules/accredited-establishments/api/types'
import { constructFilterObject } from '@/modules/accredited-establishments/functions/constructFilterObject'

interface Establishment {
  referencedId: string
  name: string
  category: EstablishmentCategory
  icon?: string
  specialities?: string[]
  subCategory?: string
  appointmentTypes?: AppointmentType[]
  address: {
    id: string
    complement?: string
    street: string
    number: string
    neighborhood: string
    city: string
    state: string
    zipcode: string
  }
  /* Opcionais ate alice-health/mono#46744 e #46746 entrarem em producao. */
  lat?: string
  lon?: string
}

interface SearchAddress {
  placeId: string
  label: string
}

/*
 * Contagem por categoria para o contador dos chips, contada com todos os
 * filtros ativos menos a propria fatia de categoria. Ausente enquanto o
 * backend nao devolve o campo.
 *
 * As chaves chegam deformadas: o interceptor de resposta roda `camelizeKeys`
 * no payload inteiro e nao distingue nome de campo de chave de mapa, entao
 * `EMERGENCY_UNITY` vira `eMERGENCYUNITY`. Leia sempre por `getCategoryCount`,
 * nunca indexando pela categoria.
 */
type CategoryCounts = Record<string, number>

export interface SearchAccreditedEstablishmentsListResponse {
  totalItems: number
  items: Establishment[]
  addressLabel?: SearchAddress
  categoryCounts?: CategoryCounts
}

export type SearchAccreditedEstablishmentsArgs = EstablishmentsArgs & {
  offset: number
  limit: number
}

export const searchEstablishmentsList = async ({
  ...args
}: SearchAccreditedEstablishmentsArgs): Promise<SearchAccreditedEstablishmentsListResponse> => {
  const filter = constructFilterObject(args)
  const { data } = await api.get<SearchAccreditedEstablishmentsListResponse>(
    `/site_accredited_network/v2/accredited?filter=${JSON.stringify(filter)}`
  )
  return data
}

export type { Establishment, SearchAddress, CategoryCounts }
